import { createContext, Dispatch, SetStateAction } from "react";
import { SubscriptionPaymentMethod } from "@shared/features/settings/subscription/types";
import { PaymentMethod } from "@shared/types";
import { SubscriptionInvoiceTypeValueType } from "analytics/events";
import {
  FormattedPlanDetails,
  FormattedPlanDetailsMapping,
  PromoCodePlansPricesType,
  PurchaseSubscriptionType,
  SubscriptionDuration,
  GetUpgradePricesResponse,
} from "@shared/types";
import {
  SetDuration,
  SubscriptionParams,
} from "@shared/features/settings/subscription/types";

interface BuySubscriptionContextValue {
  subscriptionParams: SubscriptionParams;
  plan: FormattedPlanDetails | undefined;
  plans: FormattedPlanDetailsMapping | undefined;
  duration: SubscriptionDuration;
  setDuration: SetDuration;
  setSubscriptionType: (
    subscriptionType: PurchaseSubscriptionType,
    replace?: boolean
  ) => void;
  previousStep: () => void;
  isUpgrade?: boolean;
  showUpgradePrices: boolean;
  isExtend?: boolean;
  subGroupId?: number;
  isBottomSummary: boolean;
  analyticsInvoiceType: SubscriptionInvoiceTypeValueType;
  numApiSlots: number | undefined;
  setNumApiSlots: Dispatch<SetStateAction<number | undefined>>;
  isFetching: boolean;
  isLoading: boolean;
  promoCode: string | undefined;
  setPromoCode: Dispatch<SetStateAction<string | undefined>>;
  promoCodePrices: PromoCodePlansPricesType | undefined;
  setPromoCodePrices: Dispatch<
    SetStateAction<PromoCodePlansPricesType | undefined>
  >;
  upgradePrices: GetUpgradePricesResponse | undefined;
  isUpgradePricesLoading?: boolean;
  isAutoRenewal?: boolean;
  isStandaloneApiSlots?: boolean;
  subscriptionPaymentMethod: SubscriptionPaymentMethod | undefined;
  setSubscriptionPaymentMethod: (
    paymentMethod: SubscriptionPaymentMethod | undefined
  ) => void;
  paymentMethod: PaymentMethod | undefined;
  setPaymentMethod: (paymentMethod?: PaymentMethod) => void;
  cryptoTotalPrice: string | undefined;
  setCryptoTotalPrice: Dispatch<SetStateAction<string | undefined>>;
  paymentMethods: PaymentMethod[] | undefined;
  isFetchingPaymentMethods: boolean;
  isLoadingPaymentMethods: boolean;
  additionalSlotPrice: Record<number, number> | undefined;
  isCryptoPayment?: boolean;
  queryPromoCode?: string;
  isPromoCodeApplied: boolean;
  isGetUpgradePricesEnabled?: boolean;
  extraClientSlots: number | undefined;
}

export const BuySubscriptionContext = createContext<
  BuySubscriptionContextValue | undefined
>(undefined);
